.reviews {
  border-radius: 32px;
  background: #F3EDDF;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.usersWrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  width: 100%;
}

.numberUsers {
  color: #BA61FE;
  font-family: ui-rounded, "SF Pro Rounded", Nunito, "SF Pro Text", -apple-system, BlinkMacSystemFont, "Roboto", sans-serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 800;
  line-height: 48px;
  letter-spacing: -0.4px;
}

.usersImg {
  max-height: 38px;
}

.description {
  color: #7B766F;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.045px;
}

// Dark mode
:global body.dark {
  :local {

    .reviews {
      background: #2A2928;
    }

  }
}